import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";
import { RecIcon } from "./MaterialRecordParts";

/**
 * Photo actions for a Material: Take Photo, Choose Photo (which replaces when
 * a photo exists) and Remove Photo. A compact bottom sheet on phones.
 */
export function MaterialPhotoSheet({ hasPhoto, onTake, onChoose, onRemove, onClose }) {
  useBodyScrollLock(true);

  useEffect(() => {
    const onKey = (event) => {
      if (event.key === "Escape") onClose?.();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  if (typeof document === "undefined") return null;

  return createPortal(
    <div
      className="rec-sheet-overlay"
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose?.();
      }}
    >
      <div className="rec-sheet" role="dialog" aria-modal="true" aria-label={hasPhoto ? "Replace Photo" : "Material Photo"}>
        <div className="rec-sheet__handle" aria-hidden="true" />
        <div className="rec-sheet__title">{hasPhoto ? "Replace Photo" : "Add Photo"}</div>
        <button type="button" className="rec-sheet__item" onClick={onTake}>
          <RecIcon name="camera" />
          Take Photo
        </button>
        <button type="button" className="rec-sheet__item" onClick={onChoose}>
          <RecIcon name="image" />
          Choose Photo
        </button>
        {hasPhoto ? (
          <button type="button" className="rec-sheet__item rec-sheet__item--danger" onClick={onRemove}>
            <RecIcon name="trash" />
            Remove Photo
          </button>
        ) : null}
        <button type="button" className="rec-sheet__cancel" onClick={onClose}>
          Cancel
        </button>
      </div>
    </div>,
    document.body,
  );
}
